module.exports = __webpack_public_path__ + "img/trash-bin.7630608f.svg";